module.exports = __webpack_public_path__ + "static/media/screen_calendar.00997acf.png";